export function getWorkflowUserMappings ({
  parentInstanceId,
  workflowData,
  wFstepUsers,
  startStepUsers,
  existingUsers,
  nextStepId,
  wfInstanceId,
  selectedStartingStep,
  currentStatus,
  FORM_STATE_MAP
}) {
  const wfUsersMap = new Map()
  const insertUsers = []
  const deleteUsers = []

  const hasHistory =
    parentInstanceId ||
    workflowData?.workflow_stage?.current_step_transition_history?.length > 0

  if (hasHistory) {
    // main step users
    // eslint-disable-next-line no-unused-expressions
    wFstepUsers?.forEach((item) => {
      wfUsersMap.set(item.user_id, {
        user_id: item.user_id,
        target_tenant_id: item.target_tenant_id,
        step_id: nextStepId
      })
    })

    if (existingUsers?.length > 0) {
      existingUsers.forEach((item) => {
        if (wfUsersMap.has(item.user_id)) {
          const userData = wfUsersMap.get(item.user_id)
          if (userData.target_tenant_id === item.target_tenant_id) {
            wfUsersMap.delete(item.user_id)
          }
        } else {
          deleteUsers.push(item.user_id)
          wfUsersMap.delete(item.user_id)
        }
      })
    }

    wfUsersMap.forEach((value) => insertUsers.push(value))
  } else {
    let stepId = nextStepId
    if (
      !wfInstanceId &&
      selectedStartingStep &&
      currentStatus === FORM_STATE_MAP.DRAFT
    ) {
      stepId = selectedStartingStep.id
    }

        // eslint-disable-next-line no-unused-expressions
        startStepUsers?.forEach((item) => {
          insertUsers.push({
            user_id: item.user_id,
            target_tenant_id: item.target_tenant_id,
            step_id: stepId
          })
        })
  }

  return { wfUsersMap, insertUsers, deleteUsers }
}
